<router-outlet></router-outlet>
<app-role-preview-banner></app-role-preview-banner>
<app-spinner *ngIf="showSpinner"></app-spinner>
